// extracted by mini-css-extract-plugin
export default {"statusChip":"StatusChip_statusChip__yAGzW","available":"StatusChip_available__VCtMk","unavailable":"StatusChip_unavailable__Ey7QM","clickable":"StatusChip_clickable__CJexy"};